const pageShortHand = {
  'cardmember-benefits': 'cb',
  'fine-hotels-and-resorts': 'fhr',
  'the-hotel-collection': 'thc',
};

export const convertPage = (page) => pageShortHand[page] || page;
